import { BookStyleEnum } from '@/models/Book';
import { CourseRoute, ROUTES } from '@/utils/routes';

export default function toBookHref(
  route: CourseRoute & { lessonId: number },
  bookStyle: BookStyleEnum,
) {
  return bookStyle === BookStyleEnum.APRESENTATION
    ? ROUTES.COURSES.LESSON.BOOK.SUBCHAPTER({
        ...route,
        chapterOrder: 1,
        subchapterOrder: 1,
      })
    : ROUTES.COURSES.LESSON.BOOK.CHAPTER({ ...route, chapterOrder: 1 });
}
